export default function FinalCTA() {
  return (
    <section className="py-16 sm:py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block mb-6 px-4 py-2 bg-orange-500/20 border border-orange-500 rounded-full">
            <span className="text-orange-500 text-xs sm:text-sm font-semibold tracking-wide">NÃO PERCA ESSA OPORTUNIDADE</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Garanta sua vaga no campeonato mais competitivo de GT4 do Brasil
          </h2>

          <p className="text-base sm:text-lg text-gray-300 mb-10 leading-relaxed">
            Faça sua inscrição agora e prepare-se para disputar cada posição na pista com os melhores pilotos virtuais do país.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="https://forms.gle/tTc5BatSeyfwnPFJ8"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 text-base sm:text-lg whitespace-nowrap cursor-pointer text-center"
            >
              Fazer inscrição
            </a>
            <a 
              href="https://chat.whatsapp.com/B8pgKs2dDmD57QLiP896ds"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white font-semibold rounded-lg transition-all duration-300 text-base sm:text-lg whitespace-nowrap cursor-pointer text-center"
            >
              Entrar no grupo oficial
            </a>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-700">
            <p className="text-sm text-gray-400">
              Prazo final para inscrição: <strong className="text-orange-500">01/02/2026 às 23:59</strong> (Horário de Brasília)
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
